import React from "react";
import Navbar from "../components/Navbar.jsx";
import Footer from "../components/Footer.jsx";

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar />
      <main className="max-w-5xl mx-auto px-6 py-20 space-y-16">
        {/* Body */}
        <section className="space-y-10">
            <header className=" space-y-2"> <h1 className="text-4xl font-bold">AgoraVoiceAI - Privacy Policy</h1> <p className="text-gray-500 text-sm">Last Updated: December 5, 2025</p> </header>
          <p>
            Palladian Technologies LTD (“AgoraVoiceAI”, “we”, “us”, or “our”) is
            committed to protecting your privacy. This Privacy Policy explains
            how we collect, use, and safeguard information when you use our
            platform and services (“Service”).
          </p>

          <div>
            <h2 className="text-2xl font-semibold border-b pb-2">
              1. Information We Collect
            </h2>

            <h3 className="text-lg font-medium mt-4">
              A. Account and Business Information
            </h3>
            <p>
              We collect details such as your name, email address, company name,
              and payment information (handled securely through Stripe).
            </p>

            <h3 className="text-lg font-medium mt-4">
              B. Voice and Conversation Data
            </h3>
            <p>We collect:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Audio recordings provided by you or your customers.</li>
              <li>Transcripts of those recordings.</li>
              <li>
                Conversation metadata such as timestamps and call duration.
              </li>
            </ul>

            <h3 className="text-lg font-medium mt-4">C. Usage Data</h3>
            <p>
              We automatically collect IP addresses, device details, browser
              type, session duration, visited pages, errors, and general log
              information.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold border-b pb-2">
              2. How We Use Your Information
            </h2>
            <ul className="list-disc ml-6 space-y-1 mt-2">
              <li>To operate and maintain the AgoraVoiceAI service.</li>
              <li>To process payments and transactions.</li>
              <li>To improve AI models and troubleshoot technical issues.</li>
              <li>To enhance features using anonymized data.</li>
              <li>To comply with legal obligations.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold border-b pb-2">
              3. Biometric Information Notice
            </h2>
            <p>
              We do NOT collect biometric identifiers. We do not create or store
              voiceprints or use audio data to identify individuals.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold border-b pb-2">
              4. AI Sub-Processors & Data Sharing
            </h2>
            <ul className="list-disc ml-6 space-y-1 mt-2">
              <li>
                <strong>Google Gemini:</strong> For text and AI processing.
              </li>
              <li>
                <strong>Stripe:</strong> For secure payment processing.
              </li>
              <li>
                <strong>Cloud Providers (AWS, GCP):</strong> For hosting and
                storage.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold border-b pb-2">
              5. Data Retention
            </h2>
            <ul className="list-disc ml-6 space-y-1 mt-2">
              <li>
                <strong>Audio Data:</strong> Stored up to 365 days, then
                deleted.
              </li>
              <li>
                <strong>Account Data:</strong> Retained while your account is
                active.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold border-b pb-2">
              6. Children’s Privacy
            </h2>
            <p>
              Our service is for users 18+. We do not knowingly collect
              information from children under 13.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold border-b pb-2">
              7. Your Rights
            </h2>
            <ul className="list-disc ml-6 space-y-1 mt-2">
              <li>Request access to your data.</li>
              <li>Request corrections.</li>
              <li>Request deletion (with some legal limits).</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold border-b pb-2">
              8. Security
            </h2>
            <p>
              We use commercially reasonable security measures, but no system is
              100% secure.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold border-b pb-2">
              9. Policy Updates
            </h2>
            <p>
              We may update this Privacy Policy. Changes will be posted with a
              new “Last Updated” date.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold border-b pb-2">
              10. Contact Us
            </h2>
            <p>
              Palladian Technologies LTD
              <br />
              AgoraVoiceAI Service
              <br />
              info@agoravoice.ai
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
